import { SETTINGS_INTEGRATIONS } from '../settings-paths';
import { SettingsGroupCard, SettingsNavItem, SettingsSubPageShell } from '../settings-shared';

export function SettingsOzonDataPage() {
  return (
    <SettingsSubPageShell title="Данные с Ozon" backTo={SETTINGS_INTEGRATIONS}>
      <SettingsGroupCard title="Выгрузки">
        <SettingsNavItem
          title="Финансовые операции"
          subTitle="Начисления по дням"
          to="/settings/integration/ozon-data/finance"
          isLast
        />
      </SettingsGroupCard>
    </SettingsSubPageShell>
  );
}
